export default __webpack_public_path__ + "static/media/018-greenhouse effect.b2905cf7.svg";